import Vue from 'vue';
import Router from 'vue-router';
import HospitalMedico from './views/HospitalMedico.vue';
import Hospital from './views/Hospital.vue';
import Protocolo from './views/Protocolo.vue';
import SearchSaude from '@/views/SearchSaude.vue';
import SearchSaudeFavoritos from '@/views/SearchSaudeFavoritos.vue';
import SearchProtocolo from '@/views/SearchProtocolo.vue';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    },
    routes: [
        {path: '/index.html', redirect: '/'},
        {
            path: '/',
            name: 'Search',
            component: SearchSaude,
        },
        {
            // path: '/:medico',
            path: '/',
            name: 'SearchSaudeMedico',
            component: SearchSaude,
            props: (route) => ({ medico: route.params.medico }),
        },
        {
            path: '/saudelogged/:user/:token',
            name: 'SearchSaudeLogged',
            component: SearchSaude,
        },        {
            path: '/acordosfavoritos',
            name: 'AcordosFavoritos',
            component: SearchSaudeFavoritos,
        },
        {
            path: '/acordosfavoritos/:user/:token',
            name: 'AcordosFavoritosLogged',
            component: SearchSaudeFavoritos,
        },
        {
            path: '/search/saude',
            name: 'SearchSaude',
            component: SearchSaude,
        },
        {
            path: '/search/protocolos',
            name: 'SearchProtocolo',
            component: SearchProtocolo,
        },
        {
            path: '/search/protocolos/:categoria',
            name: 'SearchProtocoloCategoria',
            component: SearchProtocolo,
        },
        {
            path: '/hospital/:id/:medico',
            name: 'HospitalMedico',
            component: HospitalMedico,
            props: (route) => ({ origin: route.params.from }),
        },
        {
            path: '/hospital/:id',
            name: 'Hospital',
            component: Hospital,
            props: (route) => ({ origin: route.params.from }),
        },
        {
            path: '/protocolo/:id',
            name: 'Protocolo',
            component: Protocolo,
        },
    ],
});
